import { Injectable } from '@angular/core';
import { ReportAPI } from "@easyfo/common-lib";

@Injectable({
  providedIn: 'root',
})
export class ReportService {

  constructor(private reportAPI: ReportAPI) {

  }

  getPreview(jwt: string, passcode: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.reportAPI.requestPreview(jwt, passcode)
        .subscribe({
          next: (buffer: ArrayBuffer) => {
            let file = new Blob([buffer], { type: 'application/pdf' });
            let fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_self");
          },
          error: (err: any) => {
            reject(err);
          }
        });
    });
  }
}
